import InAppNotificationList from './InAppNotificationList';
import InAppNotificationShow from './InAppNotificationShow';
import InAppNotificationCreate from './InAppNotificationCreate';

export default {
    list: InAppNotificationList,
    show: InAppNotificationShow,
    create: InAppNotificationCreate
}